import { useEffect } from "react";
import Hero from "@/components/sections/Hero";
import Marquee from "@/components/sections/Marquee";
import Intro from "@/components/sections/Intro";
import HowItWorks from "@/components/sections/HowItWorks";
import Trust from "@/components/sections/Trust";
import Projects from "@/components/sections/Projects";
import Purpose from "@/components/sections/Purpose";
import Contact from "@/components/sections/Contact";
import { useI18n } from "@/i18n/I18nContext";

export default function Home() {
  const { t } = useI18n();
  useEffect(() => {
    document.title = t("meta.title");
    const desc = document.querySelector('meta[name="description"]');
    if (desc) desc.setAttribute("content", t("meta.description"));
  }, [t]);
  return (
    <main data-testid="home">
      <Hero />
      <Marquee />
      <Intro />
      <HowItWorks />
      <Trust />
      <Projects />
      <Purpose />
      <Contact />
    </main>
  );
}
